































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import BalanceTable from '@/components/BalanceTable.vue';
@Component({
  components: {BalanceTable},
})
export default class CardBalance extends CompanyMixin {
 }
